import { render, staticRenderFns } from "./webhook.add.vue?vue&type=template&id=babe4bb2&"
import script from "./webhook.add.vue?vue&type=script&lang=js&"
export * from "./webhook.add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports